import {createSlice} from '@reduxjs/toolkit';

const currencyRatesSlice = createSlice({
    name: 'currencyRates',
    initialState: [],
    reducers: {
        setCurrencyRates: (_, action) => action.payload,
        addCurrencyRate: (state, action) => [...state, action.payload],
        updateCurrencyRateById: (state, action) =>
            state.map(r => r.id === action.payload.id ? action.payload : r),
        removeCurrencyRateById: (state, action) =>
            state.filter(r => r.id !== action.payload),
    },
    selectors: {
        selectCurrencyRates: (state) => state,
    },
});

export const {setCurrencyRates, addCurrencyRate, updateCurrencyRateById, removeCurrencyRateById} = currencyRatesSlice.actions;
export const {selectCurrencyRates} = currencyRatesSlice.selectors;
export const {reducer} = currencyRatesSlice;
